import { render } from "./Answer.vue?vue&type=template&id=02fdb808&scoped=true&ts=true"
import script from "./Answer.vue?vue&type=script&lang=ts"
export * from "./Answer.vue?vue&type=script&lang=ts"

import "./Answer.vue?vue&type=style&index=0&id=02fdb808&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\src\\BespokeRetirements.UI.Web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02fdb808"]])

export default __exports__